module.exports = __webpack_public_path__ + "img/bs_silo_5.2b4127cc.png";